import { render, staticRenderFns } from "./purchaseInvoiceHistory.vue?vue&type=template&id=411b2a4d&scoped=true"
import script from "./purchaseInvoiceHistory.vue?vue&type=script&lang=js"
export * from "./purchaseInvoiceHistory.vue?vue&type=script&lang=js"
import style0 from "./purchaseInvoiceHistory.vue?vue&type=style&index=0&id=411b2a4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411b2a4d",
  null
  
)

export default component.exports